import { useLoadGoogleMaps } from './hooks/useLoadGoogleMaps';
import Routing from './routing/Routing';
import { NotificationProvider } from "./components/Notifications/NotificationsContext";
//added for GoogleDrive and token
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  const mapsReady = useLoadGoogleMaps();

  if (!mapsReady) return <div>Učitavanje mapa...</div>;

  return (
    <GoogleOAuthProvider clientId="583275220286-ehmmab77l38e0m3ok3afj6qutdmbk9uq.apps.googleusercontent.com">
      <NotificationProvider>
        <Routing />
      </NotificationProvider>
    </GoogleOAuthProvider >
  );
}

export default App;
